export default "<!-- <div class=\"fullPage\"> -->\n  <div>\n    <app-header></app-header>\n\n    <router-outlet></router-outlet>\n\n  </div>\n"